import { render, staticRenderFns } from "./ProfileTypes.vue?vue&type=template&id=2c783f9c&scoped=true&"
import script from "./ProfileTypes.vue?vue&type=script&lang=js&"
export * from "./ProfileTypes.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTypes.vue?vue&type=style&index=0&id=2c783f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c783f9c",
  null
  
)

export default component.exports